import { Navigate } from "react-router-dom";
import React, { useContext } from "react";
import SessionContext from "app/contexts/SessionContext";

const MyAllocationsPage = () => {
    const session = useContext(SessionContext);
    return (
        <Navigate
            to={`${globalThis.config.routes.allocation}?userId=${session.legacyId}`}
            replace
        />
    );
};

export default MyAllocationsPage;
